import { customElement } from 'lit/decorators.js';
import { EventBoolean, EventTemplate, Snippet } from '../../../webmodule-common/other/ui/events';
import { html } from 'lit';
import { Quote } from '../../api/dealer-api-interface-quote';
import { QuoteContainerManager } from '../data/quote-container';
import { ViewBase } from '../../../webmodule-common/other/ui/view-base';

export interface QuoteSupplierGlassViewOptions {
  quoteManager: QuoteContainerManager;
  forceReadonly: EventBoolean;
}
@customElement('wm-quotesupplierglassview')
export class QuoteSupplierGlassView extends ViewBase {
  quoteManager: QuoteContainerManager;
  forceReadonly: EventBoolean;

  constructor(options: QuoteSupplierGlassViewOptions) {
    super();
    this.quoteManager = options.quoteManager;
    this.forceReadonly = options.forceReadonly;
  }
  async afterConstruction(): Promise<void> {
    await this.quoteManager.needsQuote();
  }

  getValidationErrors(): string[] {
    return [];
  }

  async prepareForSave() {
    //nothing to do
  }

  buttonMenu(): Snippet {
    return html``;
  }

  get supplierId(): string {
    return this.quoteManager.quote.supplierId;
  }
  get quote(): Quote {
    return this.quoteManager.quote;
  }

  protected template(): EventTemplate {
    return html``;
  }
  releaseResources() {
    //override if needed
  }
  public async refresh(): Promise<void> {
    //override;
  }
}
